// removed by extract-text-webpack-plugin
module.exports = {"container":"Meetings-container","header":"Meetings-header","content":"Meetings-content","buttonBar":"Meetings-buttonBar","tabsContainer":"Meetings-tabsContainer"};